import React from 'react';
import Media from 'react-media';
import { useKeyHack } from 'day8-react';
import {
  BREAKPOINTS
} from 'day8-react/build/new-components';
import WhatIsTSW from '../WhatIsTSW';

const ChamonixHotels = () => {
  const key = useKeyHack();
  const data = {
    items: [
      {
        title: 'Entertainment',
        text: 'Imagine a reinvention of the modern cabaret, but on a high-altitude snowy stage starring dancers, divas and DJs alike... LFD is ready to seduce you with their creative curiosity, with the aim to “consume without moderation”. Guaranteed by the experts to be an après-ski that you will never forget.',
        imagelist: [
          {
            image: {
              id: 3,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-1.jpg',
              alt: 'Entertainment 1'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 4,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-2.jpg',
              alt: 'Entertainment 2'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 5,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-3.jpg',
              alt: 'Entertainment 3'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 6,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-4.jpg',
              alt: 'Entertainment 4'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 7,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-5.jpg',
              alt: 'Entertainment 5'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 8,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-6.jpg',
              alt: 'Entertainment 6'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 9,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-7.jpg',
              alt: 'Entertainment 7'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 10,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/entertainment-8.jpg',
              alt: 'Entertainment 8'
            },
            ratio: 'aspect-2-3'
          }
        ]
      },
      {
        title: 'Cuisine',
        text: 'From hand-crafted pâttiseries to mouthwatering fondues, pick from 3 signature restaurants just a stone’s throw away from your bedroom. Let the hotel chefs tantalise your tastebuds with their authentic French fine dining, with a modern twist.',
        imagelist: [
          {
            image: {
              id: 0,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/cuisine-1.jpg',
              alt: 'Cuisine 1'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 1,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/cuisine-2.jpg',
              alt: 'Cuisine 2'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 2,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/cuisine-3.jpg',
              alt: 'Cuisine 3'
            },
            ratio: 'aspect-2-3'
          }
        ]
      },
      {
        title: 'Spa',
        text: 'And breathe... As we always say at your own pace, siestas and fiestas alike. Unwind from your day on the mountain in the wellness spa and open air pool, camouflaged into the Alps’ breathtaking backdrop.',
        imagelist: [
          {
            image: {
              id: 11,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/spa-1.jpg',
              alt: 'Spa 1'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 12,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/spa-2.jpg',
              alt: 'Spa 2'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 13,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/spa-3.jpg',
              alt: 'Spa 3'
            },
            ratio: 'aspect-2-3'
          },
          {
            image: {
              id: 14,
              url: 'https://cdn.theskiweek.com/images/destinations/chamonix/spa-4.jpg',
              alt: 'Spa 4'
            },
            ratio: 'aspect-2-3'
          }
        ]
      }
    ],
    title: 'Introducing La Folie Douce',
    text: 'The LFD reputation lies in the strength of its core values : originality, freedom, and an undying thirst to “keep it real”.'
  };
  return (
    <Media key={key} query={{ minWidth: BREAKPOINTS.SM }}>
      {matches => (
        <div
          className={`padding-y-lg ${!matches && 'd8-u-bg-img'}`}
          style={matches ? ({
            backgroundImage: 'url(https://cdn.theskiweek.com/images/destinations/chamonix/enseigne-fd.png)',
            backgroundPosition: 'top',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat'
          }) : ({ backgroundImage: 'url(https://cdn.theskiweek.com/images/destinations/chamonix/enseigne-fd.png)' })}
        >
          <WhatIsTSW data={data} isChamonix />
        </div>
      )}
    </Media>
  );
};

export default ChamonixHotels;
